import * as React from 'react';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import PropTypes from 'prop-types';
import { CheckBox, Settings } from '@mui/icons-material';
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import SoftBox from 'components/SoftBox';
import { Card, Checkbox, FormControlLabel, FormGroup, Grid, Popover } from '@mui/material';

function HeatmapSettings({ settings, setSettings }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [localSettings, setLocalSettings] = React.useState(settings);

    const handleClick = (event) => {
        console.log(event)
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (field, value) => {
        // console.log(settings)
        setLocalSettings(function (current) {
            current[field] = value

            return { ...current, [field]: value };
        })
    };

    const applySettings = () => {
        setSettings({ ...localSettings });
        handleClose();
    }

    const options = [
        {
            field: "trams",
            label: "Trams"
        },
        {
            field: "buses",
            label: "Buses"
        },
        {
            field: "time_of_day",
            label: "Time Of Day"
        },
        {
            field: "three_d",
            label: "3D Objects"
        }
    ]

    const renderedOptions = options.map((row, index) => {
        return (<FormControlLabel control={<Checkbox defaultChecked size="large" />} checked={localSettings[row.field]} onChange={(value) => { handleChange(row.field, value.target.checked) }} {...{ label: row.label, index }} />)
    })



    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <div>
            <SoftButton aria-describedby={id} type="button" onClick={handleClick}>
                <SoftTypography><Settings /> Settings</SoftTypography>
            </SoftButton>
            <Popover id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Card sx={{ width: '300px', p: 2 }}>
                    <FormGroup>
                        {renderedOptions}
                    </FormGroup>
                    <SoftButton onClick={applySettings}>
                        Apply
                    </SoftButton>
                </Card>
            </Popover>
        </div>
    );
}

HeatmapSettings.propTypes = {
    settings: PropTypes.object,
    setSettings: PropTypes.func
}

export default HeatmapSettings;


